/* Header returns on scroll up (2026-09-28). States: in place (normal flow) -> parked (sticky, translated out of view, only once the
   header has fully scrolled out, so nothing moves) -> shown (slides in after 8px of scroll up) -> hidden again after 8px of scroll down.
   Back at its natural place it simply un-parks. Leaves the header alone while the home load curtain runs and while the phone menu is
   open; keyboard focus inside a parked header brings it back. iOS overscroll bounce is ignored (scroll is clamped to the real range).
   Motion lives in elysian-header-return.css. Without this file the header scrolls away as before. */
(function () {
  'use strict';
  var wrap = document.querySelector('.ely-section-header-wrap');
  if (!wrap || !wrap.parentNode || !window.requestAnimationFrame) return;
  var root = document.documentElement;
  var details = wrap.querySelector('.ely-nav__details');
  var THRESHOLD = 8;

  /* the header's natural top, measured only while it sits in normal flow (a zero-height marker measured wrong inside the
     layout grid, 2026-09-28), refreshed on resize */
  var natural = 0;
  function measure() { if (!parked) natural = wrap.getBoundingClientRect().top + (window.pageYOffset || 0); }

  var parked = false, shown = false, lastY = 0, anchor = 0, dir = 0, ticking = false;

  function y() {
    var max = Math.max(0, root.scrollHeight - window.innerHeight);
    var v = window.pageYOffset || root.scrollTop || 0;
    return v < 0 ? 0 : (v > max ? max : v);
  }
  function natTop() { return natural; }
  function instant(fn) {
    wrap.classList.add('ely-hr--instant');
    fn();
    void wrap.offsetWidth;
    wrap.classList.remove('ely-hr--instant');
  }
  function park() { instant(function () { wrap.classList.add('ely-hr--parked'); wrap.classList.remove('ely-hr--shown'); }); parked = true; shown = false; }
  function unpark() { instant(function () { wrap.classList.remove('ely-hr--parked', 'ely-hr--shown'); }); parked = false; shown = false; measure(); }
  function show() { shown = true; void wrap.offsetHeight; window.requestAnimationFrame(function () { if (shown) wrap.classList.add('ely-hr--shown'); }); }
  function hide() { wrap.classList.remove('ely-hr--shown'); shown = false; }
  function busy() {
    return root.classList.contains('ely-curtain-on') || (details && details.open);
  }

  function update() {
    ticking = false;
    var now = y();
    if (busy()) { lastY = anchor = now; return; }
    var top = natTop();
    var bottom = top + wrap.offsetHeight;
    var d = now > lastY ? 1 : (now < lastY ? -1 : 0);
    if (d && d !== dir) { dir = d; anchor = lastY; }

    if (!parked) {
      if (now > bottom) { park(); anchor = now; }
    } else if (now <= top) {
      unpark();
    } else if (!shown && now <= bottom) {
      unpark();
    } else if (d < 0 && !shown && anchor - now >= THRESHOLD) {
      show();
    } else if (d > 0 && shown && now > bottom && now - anchor >= THRESHOLD) {
      hide();
    }
    lastY = now;
  }
  function onScroll() {
    if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', function () { measure(); onScroll(); }, { passive: true });
  /* tabbing into the parked header brings it back */
  wrap.addEventListener('focusin', function () { if (parked && !shown) show(); });
  /* bfcache restore: start from the restored position without motion */
  window.addEventListener('pageshow', function (e) { if (e.persisted) { unpark(); lastY = anchor = y(); onScroll(); } });
  measure();
  lastY = anchor = y();
  update();
})();
